import React from 'react';
import { Link, useParams } from 'react-router-dom';

function AddPowerOfficialsBreadCrumb() {
  const {id, plantName} = useParams();
      // Convert slug (with -) back to spaces
      const decodedPlantName = plantName.replace(/-/g, ' ');
  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title">{decodedPlantName}</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={`/powergenerationdashboard/${plantName.replace(
                    /\s+/g,
                    "-"
                  )}/${id}`} className="breadcrumb-link">Power Generation Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/powergenplant-officials/${plantName}/${id}`} className="breadcrumb-link">Power Generation Plant Officials</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
                Add Power Generation  Plant Officials
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default AddPowerOfficialsBreadCrumb;
